import { useEffect } from "react";
import { connect } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Spin } from "antd";
import { bindActionCreators } from "redux";
import { Creators } from "store/multiple-realms/multiple-realms-duck";
import Cookies from "universal-cookie";
import * as S from "./styled/index.styled";

interface IPropsScreenSignIn {
  isLoading?: boolean;
}
interface IDispatchProps {
  multipleRealmsGetTokenAsync?: (...args) => void;
}

export type IPropsSignIn = IPropsScreenSignIn & IDispatchProps;

const SignIn = ({ multipleRealmsGetTokenAsync, isLoading }: IPropsSignIn) => {
  const cookies = new Cookies();

  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const realmName = cookies.get("ssoRealmName");

  useEffect(() => {
    multipleRealmsGetTokenAsync(realmName, code);
  }, [multipleRealmsGetTokenAsync, code, realmName]);

  if (isLoading) {
    return (
      <S.LoadingContainer>
        <Spin />
      </S.LoadingContainer>
    );
  }

  return <></>;
};

const mapStateToProps = (state) => ({
  isLoading: state.MultipleRealms.isLoading,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(Creators, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
